/* TODO: Move packages/bots/src/services/meta-tags.ts functions to this package */

import { Resource } from '@medplum/fhirtypes';

export function getMetaTag<T extends Resource>(resource: T, system: string) {
  return resource?.meta?.tag?.find((tag) => tag.system === system) || undefined;
}
